const ServicesSection = () => {
  return (
    <section id="servicios" className="py-32 bg-[#f7f3f0]">
      <div className="container-custom section-padding">
        <div className="max-w-6xl mx-auto">
          {/* Servicios de modelaje */}
          <div className="mb-32 animate-slide-up">
            <h2 className="text-5xl lg:text-6xl font-light museo-font text-[#3a3a3a] mb-12 text-center">
              Servicios de modelaje
            </h2>
            <p className="text-xl text-[#3a3a3a]/80 mb-16 text-center max-w-4xl mx-auto leading-relaxed">
              Ofrecemos talento femenino altamente curado para proyectos donde la elegancia moderna y la coherencia visual son imprescindibles.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
              <div className="bg-white p-10 rounded-sm shadow-lg hover:shadow-xl transition-all duration-500 group">
                <div className="w-16 h-16 flex items-center justify-center mb-8">
                  <i className="ri-vip-crown-line text-3xl text-[#ffb7b4] group-hover:scale-110 transition-transform duration-300"></i>
                </div>
                <h3 className="text-2xl museo-font text-[#3a3a3a] mb-6 font-medium">
                  Modelaje para eventos premium
                </h3>
                <p className="text-lg text-[#3a3a3a]/80 leading-relaxed">
                  Modelos especializadas en adaptarse a códigos estéticos y experienciales de marcas de alto nivel.
                </p>
              </div>

              <div className="bg-white p-10 rounded-sm shadow-lg hover:shadow-xl transition-all duration-500 group">
                <div className="w-16 h-16 flex items-center justify-center mb-8">
                  <i className="ri-palette-line text-3xl text-[#ffb7b4] group-hover:scale-110 transition-transform duration-300"></i>
                </div>
                <h3 className="text-2xl museo-font text-[#3a3a3a] mb-6 font-medium">
                  Modelaje para moda y brand experiences
                </h3>
                <p className="text-lg text-[#3a3a3a]/80 leading-relaxed">
                  Presencias capaces de integrarse en universos de marca, encarnando su espíritu sin perder autenticidad.
                </p>
              </div>

              <div className="bg-white p-10 rounded-sm shadow-lg hover:shadow-xl transition-all duration-500 group">
                <div className="w-16 h-16 flex items-center justify-center mb-8">
                  <i className="ri-user-star-line text-3xl text-[#ffb7b4] group-hover:scale-110 transition-transform duration-300"></i>
                </div>
                <h3 className="text-2xl museo-font text-[#3a3a3a] mb-6 font-medium">
                  Embajadoras de marca
                </h3>
                <p className="text-lg text-[#3a3a3a]/80 leading-relaxed">
                  Perfiles con criterio y estilo que amplifican el mensaje de la firma desde la naturalidad, no desde el artificio.
                </p>
              </div>
            </div>
          </div>

          {/* Producción de eventos premium */}
          <div className="mb-32">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div className="order-2 lg:order-1 animate-scale-in">
                <img 
                  src="https://static.readdy.ai/image/eeca736fc8054caf90a8ed02ed251b58/16f60a7fc26736c10c4bdc23cc285941.png"
                  alt="Producción de eventos premium"
                  className="w-full h-[600px] object-cover object-center rounded-sm shadow-2xl"
                />
              </div>
              <div className="order-1 lg:order-2 animate-slide-up">
                <h2 className="text-5xl lg:text-6xl font-light museo-font text-[#3a3a3a] mb-12">
                  Producción de eventos premium
                </h2>
                <div className="space-y-6 text-lg text-[#3a3a3a]/90 leading-relaxed">
                  <p>
                    Aquí es donde altta deja clara su diferencia real. No solo proporcionamos talento: Diseñamos y ejecutamos experiencias completas dentro del universo del lujo.
                  </p>
                  <p className="font-medium text-[#3a3a3a]">Incluye:</p>
                  <ul className="space-y-3 ml-6">
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Concepto creativo</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Dirección y producción integral</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Coordinación de estilismo y escenografía</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Selección y dirección del talento</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Anfitrionaje de alto nivel</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Performances artísticas</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Gestión logística</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Control de coherencia estética en cada fase</span>
                    </li>
                  </ul>
                  <p>
                    Trabajamos desde la primera idea hasta el último gesto del evento. Nuestro sello es evidente: sofisticación, impecabilidad operativa y una sensibilidad estética que pocas empresas del sector se atreven a exigir.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Nuestro enfoque y propuesta de valor */}
          <div className="animate-slide-up">
            <h2 className="text-5xl lg:text-6xl font-light museo-font text-[#3a3a3a] mb-12 text-center">
              Nuestro enfoque y propuesta de valor
            </h2>
            
            {/* Grid de imágenes + texto */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
              <div className="bg-white rounded-sm p-12 shadow-lg">
                <div className="space-y-8 text-lg text-[#3a3a3a]/90 leading-relaxed">
                  <p>
                    Creemos que el verdadero lujo ya no es parecer. Es ser. Y esa es la esencia de altta talent studio: un ecosistema que une modelaje contemporáneo, experiencias premium y narrativa de marca.
                  </p>
                  <p>
                    Las firmas no obtienen simplemente profesionales. Obtienen mujeres que entienden el ADN de cada marca y evento y lo transmiten con autenticidad. Aquí no se busca uniformidad. Se busca equilibrio entre personalidad y proyecto. Entre esencia propia y estética de marca. Entre elegancia y presencia.
                  </p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-6">
                <img 
                  src="https://static.readdy.ai/image/eeca736fc8054caf90a8ed02ed251b58/5b3a182c47f6e23f9cfb1e1d00c71c0c.webp"
                  alt="Enfoque Altta - Autenticidad"
                  className="w-full h-full object-cover object-top rounded-sm shadow-lg"
                />
                <img 
                  src="https://static.readdy.ai/image/eeca736fc8054caf90a8ed02ed251b58/a05a9ccd71093d5b22afac5bee730f02.webp"
                  alt="Enfoque Altta - Elegancia"
                  className="w-full h-full object-cover object-top rounded-sm shadow-lg"
                />
              </div>
            </div>

            {/* Por qué altta es diferente */}
            <div className="bg-white rounded-sm overflow-hidden shadow-lg">
              <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="p-12">
                  <h3 className="text-3xl museo-font text-[#3a3a3a] mb-10 font-medium">
                    Por qué altta es diferente
                  </h3>
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <span className="text-[#ffb7b4] mr-4 text-xl">•</span>
                      <span className="text-lg text-[#3a3a3a]/90">Talento seleccionado por identidad, no por molde</span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-[#ffb7b4] mr-4 text-xl">•</span>
                      <span className="text-lg text-[#3a3a3a]/90">Estética de lujo contemporáneo, sin clichés</span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-[#ffb7b4] mr-4 text-xl">•</span>
                      <span className="text-lg text-[#3a3a3a]/90">Modelos con criterio y carisma</span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-[#ffb7b4] mr-4 text-xl">•</span>
                      <span className="text-lg text-[#3a3a3a]/90">Integración real en la narrativa de cada marca</span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-[#ffb7b4] mr-4 text-xl">•</span>
                      <span className="text-lg text-[#3a3a3a]/90">Producción de eventos con visión creativa y ejecución impecable</span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-[#ffb7b4] mr-4 text-xl">•</span>
                      <span className="text-lg text-[#3a3a3a]/90">Coherencia visual como estándar, no como extra</span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-[#ffb7b4] mr-4 text-xl">•</span>
                      <span className="text-lg text-[#3a3a3a]/90">Un enfoque honesto: no vendemos "apariencia", vendemos autenticidad estratégica</span>
                    </div>
                  </div>
                </div>
                
                <div className="relative h-full min-h-[500px]">
                  <img 
                    src="https://static.readdy.ai/image/eeca736fc8054caf90a8ed02ed251b58/c9d54c54c61e48a1f478aed4ba4898b8.webp"
                    alt="Por qué Altta es diferente"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;